export default class ClickToCallNumber {

    /**
     * @param element
     * @param gtm
     */
    constructor(element, gtm) {
        this.$element = $(element);
        this.gtm = gtm;
        this.number = this.$element.data('click-to-call-number');
        this.extraparam = this.$element.data('extraparam');
        this.setup();
    }

    setup() {
        this.$element.off('click').on('click', (event) => {
            event.preventDefault();
            this.gtm.trackEvent('R2SPhoneBegin', this.extraparam);
            this.$element.attr('href', 'tel:' + this.number);
            window.location.href = this.$element.attr('href');
        });
    }

}
